import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconMall"><Path fillRule="evenodd" clipRule="evenodd" d="M2 6.5C2 5.11929 3.11929 4 4.5 4H19.5C20.8807 4 22 5.11929 22 6.5V17.5C22 18.8807 20.8807 20 19.5 20H4.5C3.11929 20 2 18.8807 2 17.5V6.5ZM16.5 19V13C16.5 12.1716 15.8284 11.5 15 11.5H12.5V19H16.5ZM11.5 19V11.5H9C8.17157 11.5 7.5 12.1716 7.5 13V19H11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMall;
